import React, { FC } from 'react'
import cx from 'classnames'

import { PublicationGuideBigCardProps } from '../../PublicationGuideBigCard'
import AdsCard, { AdsCardProps } from '../../AdsCard'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { Icons } from '../../Icon'

import * as SC from './styled'

export type BlockPublishAdsProps = {
  className?: string
  title: string
  text: string
  card: PublicationGuideBigCardProps
  lastAds: Array<AdsCardProps>
}

const BlockPublishAds: FC<BlockPublishAdsProps> = ({
  className,
  title,
  text,
  card,
  lastAds,
}) => {
  const matches = useMediaQuery('(min-width: 960px)')

  return (
    <SC.BlockPublishAds className={cx('BlockPublishAds', className)}>
      {matches && (
        <SC.CrossesIcon
          icon={Icons.crossesSecondary}
          width={135}
          height={106}
        />
      )}
      <SC.TitleWrapper>
        <SC.Title>{title}</SC.Title>
        <SC.DesktopText>{text}</SC.DesktopText>
      </SC.TitleWrapper>
      <SC.ContentWrapper>
        <SC.LeftWrapper>
          <SC.Card {...card} />
        </SC.LeftWrapper>
        <SC.RightWrapper>
          <SC.MobileText>{text}</SC.MobileText>
          {!matches && <SC.Slider items={lastAds} />}
          {matches && (
            <SC.Grid>
              {lastAds.map((item, index) => (
                <AdsCard key={index} {...item} />
              ))}
            </SC.Grid>
          )}
        </SC.RightWrapper>
      </SC.ContentWrapper>
    </SC.BlockPublishAds>
  )
}

export default BlockPublishAds
